import { Checkbox, FormControlLabel, Stack } from '@mui/material';
import { Control, Controller, UseFormGetValues, UseFormTrigger, useWatch } from 'react-hook-form';
import { DayName } from 'v2/hooks/useSchedules/useSchedules';
import { EditScheduleFormValues, responsiveRowSx, TimeFieldName } from '../Details/components/editScheduleUtils';
import TimeRangeFields from './TimeRangeFields';

type Props = {
  control: Control<EditScheduleFormValues>;
  getValues: UseFormGetValues<EditScheduleFormValues>;
  trigger: UseFormTrigger<EditScheduleFormValues>;
  label: string;
  fromField: TimeFieldName;
  toField: TimeFieldName;
  validationMessage: string;
  requiredMessage: string;
} & ({ alwaysEnabled: true; enabledField?: never } | { alwaysEnabled?: false; enabledField: `${DayName}.enabled` });

const ScheduleRow = (props: Props) => {
  const { control, getValues, trigger, label, fromField, toField, validationMessage, requiredMessage } = props;

  const enabledValue = useWatch({
    control,
    name: props.enabledField ?? 'monday.enabled',
    disabled: !props.enabledField
  });

  const isEnabled = props.alwaysEnabled || Boolean(enabledValue);

  return (
    <Stack direction="row" alignItems="flex-start" justifyContent="space-between" sx={responsiveRowSx}>
      <FormControlLabel
        control={
          props.alwaysEnabled ? (
            <Checkbox checked disabled color="primary" />
          ) : (
            <Controller
              name={props.enabledField}
              control={control}
              render={({ field }) => (
                <Checkbox
                  id={`${props.enabledField.replace('.', '-')}-checkbox`}
                  checked={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  slotProps={{ input: { ref: field.ref } }}
                  color="primary"
                />
              )}
            />
          )
        }
        label={label}
        sx={{ flex: 1, m: 0 }}
      />

      <TimeRangeFields
        control={control}
        fromField={fromField}
        toField={toField}
        getValues={getValues}
        trigger={trigger}
        disabled={!isEnabled}
        validationMessage={validationMessage}
        requiredMessage={requiredMessage}
      />
    </Stack>
  );
};

export default ScheduleRow;
